
import useApi from "@/api/useApi.js";
/**
 * 用于移植顺丰微派的三个接口按钮
 * @param {object} detail
 * @param {string} val
 * @returns
 */
export async function weipai(detail, val) {
  const self = this;
  const mobile = detail.user.mobile;

  if (!mobile) return this.$message.error("用户手机号不存在");

  const way = {
    place: {
      info: "电子面下单",
      func: "placeOrder",
      param: {
        order_id: detail.order_id
      },
      vNode: this.$createElement(
        "TimePicker",
        {
          on: {
            changeTime: result => (self.formInline = result)
          }
        },
        []
      )
    },
    subscribe: {
      info: "订阅单",
      func: "subscribe",
      param: {
        order_id: detail.order_id
      }
    },
    query: {
      info: "顺丰物流查询",
      func: "OrderHandle",
      param: {
        ShipperCode: detail.ShipperCode,
        CustomerName: mobile.substring(mobile.length - 4),
        LogisticCode: detail.LogisticCode
      }
    }
  }[val];

  if (way) {
    try {
      // '确定需要 顺丰微派-' + way.info + ' 吗?'
      await this.$confirm(way.vNode || '确定需要 顺丰微派-' + way.info + ' 吗?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true
      });
      if ((way.func = "placeOrder")) {
        const [StartDate, EndDate] = this.formInline.split("&");
        way.param.StartDate = StartDate + " 00:00:00";
        way.param.EndDate = EndDate + " 23:59:59";
      }
      console.log(way);
      const { msg, data } = await useApi()[way.func](way.param);
      this.$message.info(msg);
    } catch (e) {
      console.warn(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/order/order/dialog/weipai/weipai.js